import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
const FAQItem: React.FC<FAQItemProps> = ({
  question,
  answer,
  isOpen,
  onClick
}) => {
  return <div className="border-b border-terracotta/10 last:border-0" data-id="element-73">
      <button className="w-full py-6 flex justify-between items-center text-left focus:outline-none group" onClick={onClick} data-id="element-74">
        <span className="font-sans font-bold text-earth text-lg pr-8 group-hover:text-terracotta transition-colors" data-id="element-75">
          {question}
        </span>
        <ChevronDown className={`text-terracotta shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} size={24} data-id="element-76" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-77">
        <p className="font-sans text-earth-light leading-relaxed" data-id="element-78">{answer}</p>
      </div>
    </div>;
};
export const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Lo recibo ahora mismo?',
    answer: 'Sí, recibís el acceso por mail al instante después de tu compra.'
  }, {
    question: '¿Sirve para el 3er trimestre?',
    answer: 'Es el momento ideal. El método está optimizado para los meses donde la acidez se intensifica.'
  }, {
    question: '¿Tengo que dejar el mate?',
    answer: 'No. Te enseñamos exactamente cómo tomarlo de forma segura sin disparar la acidez (Manual del Mate Seguro incluido).'
  }];
  return <section className="py-16 md:py-24 px-4 max-w-3xl mx-auto" data-id="element-79">
      <h2 className="font-serif text-3xl md:text-4xl text-earth font-bold mb-10 text-center" data-id="element-80">
        Preguntas Frecuentes
      </h2>

      <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-terracotta/10" data-id="element-81">
        {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-82" />)}
      </div>
    </section>;
};